<script setup lang="ts">
import DToastStack from '../components/notifications/DToastStack.vue'
</script>
<template>
  <DToastStack class="left-14" />
  <router-view />
</template>
